import * as React from 'react';
import DatePicker from 'react-datepicker';
import cx from 'classnames';
import Head from '~/common/layout/Head';
import Button from "~/common/elements/mobile/Button";
import {buttonSize, buttonStyle} from "~/common/elements/mobile/consts";


class SalesListHeader extends React.Component<any, any> {
  constructor(props) {
    super(props);

    this.state = {
      startDate: null,
      endDate: null,
    };
  }

  onExport = (e) => {
    e.preventDefault();

    const { startDate, endDate } = this.state;

    if (startDate && endDate) {
      this.props.onExport(startDate, endDate);
    }
  };

  onExportDetail = (e) => {
    e.preventDefault();

    const { startDate, endDate } = this.state;

    if (startDate && endDate && this.props.onExportDetail) {
      this.props.onExportDetail(startDate, endDate);
    }
  };

  setStartDate = (dt) => {
    this.setState({
      startDate: dt,
    });
  };

  setEndDate = (dt) => {
    this.setState({
      endDate: dt,
    });
  };
  render = () => {
    const { onExport, onExportDetail, onCreate } = this.props;
    const { startDate, endDate } = this.state;

    const btnClass = cx('btn btn--disabled btn--tert btn--lg', {
      'btn--disabled--active': startDate && endDate && startDate <= endDate,
    });

    return (
        <Head headTitle="Sales" customStyle={{zIndex: 3}}>
          {(onExport || onExportDetail) && (
            <React.Fragment>
              <div className="input--date">
                <DatePicker
                  onChange={this.setStartDate}
                  selected={this.state.startDate}
                  popperPlacement="bottom-end"
                  placeholderText="Start Date" />
              </div>
              <div className="btn btn--text--di btn--lg">TO</div>
              <div className="input--date">
                <DatePicker
                  onChange={this.setEndDate}
                  selected={this.state.endDate}
                  popperPlacement="bottom-end"
                  placeholderText="End Date" />
              </div>
              {onExport && <a href="#" className={btnClass} onClick={this.onExport}>Export</a>}
              {onExportDetail && <a href="#" className={btnClass} onClick={this.onExportDetail}>Export Detail</a>}
              <Button title="New Sale" buttonStyle={buttonStyle.SECN} buttonSize={buttonSize.LG} onClick={onCreate} />
            </React.Fragment>
          )}
        </Head>
    );
  }
}

export default SalesListHeader;
